// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"34fc25c2","355":"ecd20d99","453":"e660b12b","633":"d98e6f4d","736":"b228d8b7"}[chunkId] + ".chunk.js";
};